<script>
   /*********************************************************
   * RMSEPlot                                               *
   * --------------------                                   *
   * shows plot for RMSE values                             *
   **********************************************************/

   import { max } from 'mdatools/stat';
   import { Vector } from 'mdatools/arrays';
   import { Axes, XAxis, YAxis, Box } from 'svelte-plots-basic/2d';

   import PlotSeries from './PlotSeries.svelte';
   import AppLegend from './AppLegend.svelte';


   /*****************************************/
   /* Input parameters                      */
   /*****************************************/

   export let model;                // PCA model object
   export let pvoptions;            // object with PV-options
   export let params;               // JSON with main plot parameters
   export let res;                  // JSON with results onkects
   export let ny = 1;               // number of response to show RMSE for (reserved for future)

   // constant parameters
   const margins = [0.75, 1, 0.1, 0.5];
   const showGrid = true;
   const xLabel = 'LVs';
   const yLabel = 'RMSE';
   const title = 'Root mean square error';

   // compute and return explaned variance
   function get_series(id, x, res) {
      if (!res || !id || !x) return null;
      return {'id': id, 'x': x, 'y': new Vector(res.stat.RMSE.getcolref(ny))};
   }


   // get values
   $: ncomp = pvoptions ? pvoptions.ncompSel : null;
   $: x = ncomp ? Vector.seq(1, ncomp) : null;
   $: ps = res ? Object.keys(res).map(id => get_series(id, x, res[id])) : null;

   // set limits
   $: limX = ncomp ? [0.5, ncomp + +.5] : [0, 1];
   $: limY = ps ? [0, 1.1 * max(Object.keys(ps).map(name => max(ps[name].y.v)))] : [0, 1];
</script>

{#if params && model && res && pvoptions && ps}
<Axes {margins} {xLabel} {yLabel} {limX} {limY} {title} >

   {#each ps as series}
   <PlotSeries values={series} type="b" />
   {/each}

   <AppLegend position={params.vartype === "cumexpvar" ? "bottomright" : "topright"}/>
   <XAxis {showGrid} slot="xaxis" />
   <YAxis {showGrid} slot="yaxis" />
   <Box slot="box" />
</Axes>
{/if}